export default __webpack_public_path__ + "static/media/india.6306289d.svg";